import React, { useContext, useEffect } from "react";
import StepAddJobs from "./StepAddJobs";
import StepMedia from "./StepMedia";
import StepDownloadApp from "./StepDownloadApp";
import StepAboutYourself from "./StepAboutYourself";
import { useNavigate, useParams } from "react-router-dom";
import { ApiResponseType, USER_ACTION_TYPE } from "../../../types";
import { makePatchCall, makePostCall } from "../../../effects/requests";
import { endPoints } from "../../../utils/endpoints";
import { MyContext } from "../../../context";
import SetpCrewLocation from "./SetpCrewLocation";
import AddReference from "./AddReference";
import { emptyFunction } from "../../../utils";
import StepAvailability from "./StepAvailability";
import StepCrewCV from "./StepCrewCV";
import { cookieService } from "../../../services";
import { cookieServiceParam } from "../../../utils/constants";

const RegisterPage: React.FC = () => {

    const { updateUserData, userData } = useContext(MyContext)

    const params = useParams();
    const navigation = useNavigate()
    const currentStep = Number(params?.step);
    const actionType = params?.type || USER_ACTION_TYPE.TYPE_ADD

    const updateUrls = (step: Number) => {
        const routeUrl = `/manage-profile/crew/${actionType}/${step}`;
        navigation(routeUrl);
    }


    const onSubmit = (value: any, isLast: boolean) => {
        makePatchCall(endPoints.PROFILE, value).then((res: ApiResponseType<any>) => {
            if (res.status?.code == 200) {
                updateUserData(res)
                if (isLast) {
                    cookieService.saveCookie(cookieServiceParam.account_completed, true);
                    navigation("/schedule");
                } else {
                    updateUrls(currentStep + 1)
                }
            }
        }).catch((error) => {

        })
    }

    const createRef = (data: any) => {
        const refPayload = data.filter((item: any) => {
            if (!item?.id) {
                item.user = userData?.id;
                return item
            }
        });
        if (refPayload?.length <= 0) {
            updateUrls(currentStep + 1)
            return
        }
        makePostCall(endPoints.REFERENCE_URL, refPayload).then(() => {
            updateUrls(currentStep + 1)
        }).catch(emptyFunction)
    }

    const addPreviousJob = (data: any) => {
        makePostCall(endPoints.PREVIOUS_WORK, data).then((res: any) => {
            updateUrls(currentStep + 1)
        }).catch(emptyFunction)
    }

    useEffect(() => {
        window.addEventListener('popstate', (e) => {
            window.history.go(1);
        });
    }, []);

    switch (currentStep) {
        case 1:
            return <StepAboutYourself
                onNext={(data: any) => {
                    onSubmit?.(data, false)
                }}
            />;
        case 2:
            return <SetpCrewLocation
                onNext={(data: any) => {
                    onSubmit?.(data, false)
                }}
                onPrevious={() => updateUrls(currentStep - 1)}
            />;
        case 3:
            return <AddReference
                onNext={(data: any) => createRef(data)}
                onPrevious={() => updateUrls(currentStep - 1)}
            />;
        case 4:
            return <StepAddJobs
                onNext={(data: any) => addPreviousJob(data)}
                onPrevious={() => updateUrls(currentStep - 1)}
                onPass={() => updateUrls(currentStep + 1)}
            />;
        case 5:
            return <StepMedia
                onNext={() => updateUrls(currentStep + 1)}
                onPrevious={() => updateUrls(currentStep - 1)}
            />;
        case 6:
            return <StepAvailability
                onNext={(data: any) => {
                    onSubmit?.(data, false)
                }}
                onPrevious={() => updateUrls(currentStep - 1)}
            />;
        case 7:
            return <StepCrewCV
                onNext={(data: any) => {
                    updateUrls(currentStep + 1)
                    // onSubmit?.(data, false)
                }}
                onPrevious={() => updateUrls(currentStep - 1)}
            />;
        case 8:
            return <StepDownloadApp
                onNext={(data: any) => {
                    onSubmit?.(data, true)
                }}
            />;
        default:
            return <StepAboutYourself
                onNext={(data: any) => {
                    onSubmit?.(data, false)
                }}
            />;
    }
};

export default RegisterPage;